import * as yup from "yup";

export const WRITE_TO_US_FORM_VALIDATION_SCHEMA = yup.object({
  message: yup
    .string()
    .trim()
    .min(1, 'Поле является обязательным')
    .max(2000, 'Введите не более 2000 символов'),
  email: yup.string().required('Введите адрес электронной почты')
    .email('Адрес электронной почты введен некорректно'),
  agree: yup.boolean().test({
    test: agree => !!agree,
    message: 'Необходимо подтведить согласие с условиями пользовательского соглашения'
  }),
  agreePolicy: yup.boolean().test({
    test: agreePolicy => !!agreePolicy,
    message: 'Необходимо подтвердить согласие с политикой обработки персональных данных'
  }),
})
